<template>
  <div class="ClientDates">

    <p v-if="client || dates">
      <span v-if="client">{{ client }}</span>
      <span v-if="client && dates"></span>
      <span v-if="dates">({{ dates }})</span>
    </p>

  </div>
</template>

<script>
export default {
  name: 'ClientDates',

  props: {
    client: {
      type: String
    },
    dates: {
      type: [String, Number]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientDates.vue?7dc8a112